import { useNavigate } from 'react-router-dom';

import { submitWizardOrchestrator } from 'api/Wizard/Wizard';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import { showAlert } from 'components/shared/Alert/Alert';

import { WIZARD_PROGRESS } from './enum';

const DEFAULT_INVALIDATE_QUERY_KEY = ['wizardInstance', 'practice', 'wizard-overview'];

export default function useOrchestratorSubmission({
  orchestratorData,
  onNext,
  invalidateQueryKey
} = {}) {
  const navigate = useNavigate();
  return useCustomMutation({
    mutationFn: async (values = {}) => {
      const handlerFields =
        values && typeof values === 'object' && !Array.isArray(values) ? values : {};
      return submitWizardOrchestrator(navigate, {
        ...orchestratorData,
        handlerFields
      });
    },
    invalidateQueryKey: [...invalidateQueryKey, ...DEFAULT_INVALIDATE_QUERY_KEY],
    onSuccess: async (orchestratorResponse) => {
      const { status, note } = orchestratorResponse?.data?.handlerStatus || {};
      let noteObj = {};
      try {
        noteObj = note ? JSON.parse(note) : {};
      } catch (_) {
        noteObj = {};
      }
      if (status === WIZARD_PROGRESS.COMPLETED) {
        onNext?.();
      } else if (status === WIZARD_PROGRESS.IN_PROGRESS) {
        onNext?.();
      } else if (status === WIZARD_PROGRESS.FAILED) {
        showAlert({
          color: 'danger',
          message: noteObj?.error || note || 'An error occurred while saving practice details.'
        });
      } else {
        showAlert({
          color: 'warning',
          message:
            noteObj?.error ||
            note ||
            'Practice details saved but not completed. Please check the form.'
        });
      }
    },
    onError: (error) => {
      showAlert({
        color: 'error',
        message: error?.message || 'An error occurred while submitting the form.'
      });
    },
    disableAlert: true
  });
}
